import { Field, Form, Formik } from "formik";
import React from "react";
import { toast } from "react-toastify";
import tw from "tailwind-styled-components";
import Loading from "../Loading";
import Model from "../Model";
import {
  CombineInputGroup,
  FieldWrapper,
  InputGroup,
  Label,
  SubmitBtn,
} from "../Styles/InputStyles";

const AddSubRegistrarModel = ({
  SingleEntryLoading,
  postSingleEntry,
  setOpenUploadModel,
}) => {
  const InitialValues = {
    type: 8,
  };

  const SubmitHandler = (values) => {
    if (!values.type) {
      toast.error("Please select user type");
      return;
    }
// console.log(values);
    postSingleEntry(values);
  };

  return (
    <Model width={`w-11/12 max-w-lg `} setOpenModel={setOpenUploadModel}>
      <Title>Add Registrar Assistant</Title>

      {SingleEntryLoading && <Loading />}

      {!SingleEntryLoading && (
        <Formik initialValues={InitialValues} onSubmit={SubmitHandler}>
          <Form>
            <Wrapper>
              <CombineInputGroup>
                <InputGroup>
                  <Label htmlFor="fName">First Name</Label>
                  <FieldWrapper>
                    <Field
                      name="fName"
                      id="fName"
                      autoComplete="off"
                      required
                    />
                  </FieldWrapper>
                </InputGroup>
                <InputGroup>
                  <Label htmlFor="lName">Last Name</Label>
                  <FieldWrapper>
                    <Field
                      name="lName"
                      id="lName"
                      autoComplete="off"
                      required
                    />
                  </FieldWrapper>
                </InputGroup>
              </CombineInputGroup>
              <CombineInputGroup>
                <InputGroup>
                  <Label htmlFor="email">Email</Label>
                  <FieldWrapper>
                    <Field
                      type="text"
                      name="email"
                      id="email"
                      autoComplete="off"
                      className="truncate"
                      required
                    />
                  </FieldWrapper>
                </InputGroup>

                <InputGroup>
                  <Label htmlFor="mobile">Phone Number</Label>
                  <FieldWrapper>
                    <Field
                      type="number"
                      name="mobile"
                      id="mobile"
                      autoComplete="off"
                      className="truncate"
                      required
                    />
                  </FieldWrapper>
                </InputGroup>
              </CombineInputGroup>
              <CombineInputGroup>
                <InputGroup>
                  <Label htmlFor="password">Password</Label>
                  <FieldWrapper>
                    <Field
                      type="password"
                      name="password"
                      id="password"
                      autoComplete="off"
                      className="truncate"
                      required
                    />
                  </FieldWrapper>
                </InputGroup>
              </CombineInputGroup>
            </Wrapper>
            <BtnWrapper>
              <SubmitBtn type="submit">Add</SubmitBtn>
            </BtnWrapper>
          </Form>
        </Formik>
      )}
    </Model>
  );
};

const Wrapper = tw.div`
grid  gap-6 my-6 px-1`;
const SampleFile = tw.a` w-full pt-3 text-blue-500 underline text-sm text-center`;

const Title = tw.h1`text-lg md:text-xl font-medium text-center text-gray-800`;
const BtnWrapper = tw.div`flex justify-center items-center`;

export default AddSubRegistrarModel;
